<template>
  <v-application>
    <v-layout class="ma-2">
      <v-flex v-bind:md6="!large" v-bind:md12="large">
        <v-card class="mb-3" :loading="loading" :disabled="disabled">
          <template v-if="ownHeader">
            <slot name="form_header" />
          </template>
          <v-toolbar flat v-else-if="!withoutTitle" pr-5>
            <v-toolbar-title>
              {{ $t(top_title) }}
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <slot />
          </v-card-text>
          <template v-if="$slots.footer">
            <slot name="footer" />
          </template>
          <v-card-actions v-if="$slots.action">
            <slot name="delete_action" />
            <v-spacer />
            <slot name="action" />
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-application>
</template>
<script>
export default {
  name: "v-form-create",
  props: {
    name: String,
    top_title: String,
    large: Boolean,
    withoutTitle: Boolean,
    loading: Boolean,
    disabled: Boolean,
    ownHeader: Boolean
  },
};
</script>